import { Flex, Grid, mediaBreakpointMixin, token } from '@zillow/constellation';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getHasSmokerRollup, getMoveInDateRollup, getOccupantsRollup, getTotalIncomeRollup } from './Household.util';
import HouseholdSection from './HouseholdSection';
import IncomeToRentRatioSection from './IncomeToRentRatioSection';

const Wrapper = styled(Grid)`
  border-top: 1px solid ${token('colors.borderLight')};
  border-bottom: 1px solid ${token('colors.borderLight')};
  align-self: stretch;

  ${HouseholdSection} {
    @media ${mediaBreakpointMixin('xl')} {
      grid-row: unset;
      grid-column: unset;
    }
  }
`;

export default function Household({ rentalListing, ...rest }) {
  const { monthlyPayment } = rentalListing;
  const { applicants, invitations } = rentalListing.landlordRentalApplication;

  return (
    <Flex display="flex" flexDirection="column" id="household-section" {...rest}>
      <Wrapper
        display="grid"
        gridTemplateColumns={{
          default: 'minmax(140px, 1fr) 1fr',
          lg: `repeat3, 1fr)`,
          xl: `repeat(3, 1fr)`,
        }}
        rowGap="md"
        columnGap={{ default: 'sm', lg: 'lg' }}
        paddingY="md"
      >
        <HouseholdSection
          title="Total income before taxes"
          text={getTotalIncomeRollup(applicants, invitations)}
          data-test="household-section-total-income"
        />
        <IncomeToRentRatioSection
          monthlyPayment={monthlyPayment}
          applicants={applicants}
          invitations={invitations}
          data-test="household-section-income-to-rent-ratio"
        />
        <HouseholdSection
          title="Move in date"
          text={getMoveInDateRollup(applicants)}
          data-test="household-section-move-in-date"
        />
        <HouseholdSection
          title="Occupants"
          text={getOccupantsRollup(applicants)}
          data-test="household-section-occupants"
        />
        <HouseholdSection title="Smokers" text={getHasSmokerRollup(applicants)} data-test="household-section-smokers" />
      </Wrapper>
    </Flex>
  );
}

Household.propTypes = {
  rentalListing: PropTypes.shape({
    monthlyPayment: PropTypes.string,
    isRentGuaranteeEnabled: PropTypes.bool,
    landlordRentalApplication: PropTypes.shape({
      applicants: PropTypes.arrayOf(
        PropTypes.shape({
          status: PropTypes.string,
          moveInDate: PropTypes.string,
          isMoveInDateFlexible: PropTypes.bool,
          isSmoker: PropTypes.bool,
          occupants: PropTypes.number,
          currentIncomes: PropTypes.arrayOf(
            PropTypes.shape({
              amount: PropTypes.string,
              documents: PropTypes.arrayOf(
                PropTypes.shape({
                  id: PropTypes.string,
                  expirationDateTime: PropTypes.string,
                }),
              ),
            }),
          ),
        }),
      ),
      invitations: PropTypes.array,
    }),
  }),
};
